/**
 * Утилиты для работы с токенами
 */

/**
 * Проверяет валидность токена
 * @param {string} token - Токен для проверки
 * @returns {boolean} - true если токен валиден
 */
export function isValidToken(token) {
  if (!token || typeof token !== 'string') {
    return false;
  }
  
  // Проверяем, что токен не пустой и не содержит только пробелы
  if (token.trim().length === 0) {
    return false;
  }
  
  // Для демо токена проверяем формат
  if (token === 'demo-token') {
    return true;
  }
  
  // Для JWT токенов проверяем базовую структуру
  const parts = token.split('.');
  if (parts.length === 3) {
    try {
      // Проверяем, что можно декодировать header и payload
      JSON.parse(atob(parts[0])); // Проверяем валидность header
      const payload = JSON.parse(atob(parts[1]));
      
      // Проверяем, что токен не истек
      if (payload.exp && payload.exp < Date.now() / 1000) {
        return false;
      }
      
      return true;
    } catch (error) {
      return false;
    }
  }
  
  return false;
}

/**
 * Получает токен из localStorage и проверяет его валидность
 * @returns {string|null} - Валидный токен или null
 */
export function getValidToken() {
  const token = localStorage.getItem('token');
  
  if (!isValidToken(token)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return null;
  }
  
  return token;
}

/**
 * Устанавливает токен в localStorage
 * @param {string} token - Токен для сохранения
 */
export function setToken(token) {
  if (isValidToken(token)) {
    localStorage.setItem('token', token);
  }
}

/**
 * Удаляет токен из localStorage
 */
export function removeToken() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

/**
 * Проверяет, является ли токен демо токеном
 * @param {string} token - Токен для проверки
 * @returns {boolean}
 */
export function isDemoToken(token) {
  return token === 'demo-token';
}


